import { render, staticRenderFns } from "./JeecgOrderMainModal.vue?vue&type=template&id=5836ed0d&scoped=true&"
import script from "./JeecgOrderMainModal.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderMainModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderMainModal.vue?vue&type=style&index=0&id=5836ed0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836ed0d",
  null
  
)

export default component.exports